var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Input, Optional, ViewChild, } from '@angular/core';
import { MatDrawer } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenInfoService } from '@synisys/idm-authentication-client-js';
import { ResourceType } from '@synisys/idm-comment-control';
import { DePermissionService, DeService, MainEntity, } from '@synisys/idm-de-service-client-js';
import { FormService, FormType } from '@synisys/idm-dynamic-layout-interpreter';
import { KbService } from '@synisys/idm-kb-service-client-js';
import { LockingService } from '@synisys/idm-lock-service-client-js';
import { LanguageService } from '@synisys/idm-message-language-service-client-js';
import { EventBase } from '@synisys/idm-session-data-provider-api-js';
import { ValidationService } from '@synisys/idm-validation-calculation-service-client-js';
import { notNil } from '@synisys/skynet-store-utilities';
import { isNil } from 'lodash';
import { Observable } from 'rxjs/Observable';
import { filter, first, mergeMap, observeOn, switchMap, takeUntil, tap, } from 'rxjs/operators';
import { async } from 'rxjs/scheduler/async';
import { Subject } from 'rxjs/Subject';
import { identity } from 'rxjs/util/identity';
import { noop } from 'rxjs/util/noop';
import { AbstractDestructionSubject } from './component/abstract-destruction-subject';
import { DynamicFormComponent } from './component/form/form.component';
import { PopupEntityComponent } from './component/popup/main-entity/popup-entity.component';
import { ActionNotificationData, ActionNotifierKey } from './concepts';
import { DrawerType } from './concepts/drawer/drawer-type.enum';
import './de.container.component.scss';
import { LockGuard } from './service';
import { ActionBuilder, StateArg } from './service/layout-actions';
import { DefaultModelDecoratorProvider } from './service/local/default-model-decorator-provider';
import { MetaFormHelperService } from './service/local/meta-form-helper.service';
var DeContainerComponent = /** @class */ (function (_super) {
    __extends(DeContainerComponent, _super);
    function DeContainerComponent(deService, _router, _activatedRoute, kbService, validationService, languageService, dePermissionService, formService, lockService, lockGuard, tokenInfoService, titleService, metaFormHelperService, defaultModelDecoratorProvider, eventBase) {
        var _this = _super.call(this) || this;
        _this.deService = deService;
        _this._router = _router;
        _this._activatedRoute = _activatedRoute;
        _this.kbService = kbService;
        _this.validationService = validationService;
        _this.languageService = languageService;
        _this.dePermissionService = dePermissionService;
        _this.formService = formService;
        _this.lockService = lockService;
        _this.lockGuard = lockGuard;
        _this.tokenInfoService = tokenInfoService;
        _this.titleService = titleService;
        _this.metaFormHelperService = metaFormHelperService;
        _this.defaultModelDecoratorProvider = defaultModelDecoratorProvider;
        _this.eventBase = eventBase;
        _this.drawerTypeEnum = DrawerType;
        _this.commentsResourceType = ResourceType;
        _this.actions = [];
        _this.isInDrawer = false;
        _this.isToggled = false;
        _this.actionNotifier = new Subject();
        _this.isReady = false;
        _this.drawerData = {};
        return _this;
    }
    Object.defineProperty(DeContainerComponent.prototype, "entity", {
        get: function () {
            return this._entity;
        },
        set: function (entity) {
            this._entity = entity;
            this.initWorkflowActions();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeContainerComponent.prototype, "metaForm", {
        get: function () {
            return this._metaForm;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeContainerComponent.prototype, "form", {
        get: function () {
            return this._form;
        },
        set: function (value) {
            this._form = value;
            this.initWorkflowActions();
        },
        enumerable: true,
        configurable: true
    });
    DeContainerComponent.prototype.ngOnChanges = function (changes) {
        if (changes['formName'] ||
            changes['categoryName'] ||
            changes['formId'] ||
            changes['entityId']) {
            if (isNil(changes['entity'])) {
                this.entity = undefined;
            }
            this.isReady = false;
            this.initContainer();
        }
    };
    DeContainerComponent.prototype.ngOnInit = function () {
        this.quickLoginHandler();
    };
    DeContainerComponent.prototype.setIsToggle = function (opened) {
        this.isToggled = opened;
        if (!opened) {
            this.actionNotifier.next(new ActionNotificationData(ActionNotifierKey.DRAWER_CLOSE_ACTION, undefined));
        }
    };
    DeContainerComponent.prototype.quickLoginHandler = function () {
        var _this = this;
        this.tokenInfoService.tokenUpdatedViaQuickLogin
            .pipe(filter(identity), mergeMap(function () {
            return _this.lockGuard.checkForLock(_this.categoryName, _this.formName, _this.entityId, _this.formId);
        }), takeUntil(this.destroySubject$))
            .subscribe(noop, console.error);
    };
    DeContainerComponent.prototype.initContainer = function () {
        var _this = this;
        this.entityInitiation()
            .pipe(switchMap(function (entity) {
            _this.initFunctions();
            return _this.metaFormHelperService.loadFormMetaModel(_this.categoryName, entity, _this.formName, _this.formId, true);
        }), first(), takeUntil(this.destroySubject$), tap(function (metaFormModel) {
            _this._metaForm = metaFormModel;
            _this.setTitle();
            _this.initWorkflowActions();
            _this.isReady = true;
        }), observeOn(async), tap(function () { return _this.initComments(); }))
            .subscribe(noop, function (err) { return console.error(err); });
    };
    DeContainerComponent.prototype.entityInitiation = function () {
        var _this = this;
        if (isNil(this.entity)) {
            var entity$ = void 0;
            if (this.entityId === null || this.entityId === undefined) {
                entity$ = this.deService
                    .createBlankEntity(this.categoryName)
                    .pipe(switchMap(function (value) {
                    return _this.defaultModelDecoratorProvider
                        ? _this.defaultModelDecoratorProvider.decorate(_this.categoryName, _this.formId, _this.isInDrawer, _this._activatedRoute.snapshot.params, _this._activatedRoute.snapshot.queryParams, _this.transientFields, value)
                        : Observable.of(value);
                }));
            }
            else {
                entity$ = this.deService
                    .loadEntityByInstanceId(this.categoryName, this.entityId, true)
                    .catch(function (error) { return _this.handleDeLoadError(error); });
            }
            return entity$.map(function (entity) {
                _this._entity = entity;
                return _this._entity;
            });
        }
        return Observable.of(this.entity);
    };
    DeContainerComponent.prototype.setTitle = function () {
        var _this = this;
        if (!this.isInDrawer &&
            this._metaForm.layoutModel.title &&
            this._metaForm.layoutModel.title.fields.length > 0) {
            this.titleService.setTitle(this._metaForm.layoutModel.title.fields
                .map(function (metaField) { return _this.entity.getProperty(metaField).value; })
                .join(' '));
        }
    };
    DeContainerComponent.prototype.initFunctions = function () {
        var _this = this;
        if (this.actions === undefined) {
            this.actions = [];
        }
        if (this.transientFields === undefined) {
            this.transientFields = [];
        }
        this.actions.push(new ActionBuilder()
            .name('newEntityPopup')
            .params([
            StateArg('drawerFormName'),
            StateArg('drawerCategory'),
            StateArg('drawerFormId'),
            StateArg('drawerParams'),
        ])
            .action(function (formName, categoryName, formId, params) {
            _this.drawerData = {
                type: DrawerType.ENTITY,
                formName: formName,
                category: categoryName,
                formId: formId,
                params: params,
                entityId: undefined,
            };
            _this.formService
                .loadFormTypeId(formName, formId, categoryName)
                .pipe(takeUntil(_this.destroySubject$))
                .subscribe(function (type) {
                _this.drawerClosable =
                    type === FormType.VIEW;
                _this.drawer.toggle();
            }, function (err) { return console.error(err); });
        })
            .build());
        this.actions.push(new ActionBuilder()
            .name('editEntityPopup')
            .params([
            StateArg('drawerFormName'),
            StateArg('drawerCategory'),
            StateArg('drawerFormId'),
            StateArg('drawerEntityId'),
            StateArg('drawerParams'),
        ])
            .action(function (formName, categoryName, formId, entityId, params) {
            _this.lockGuard
                .checkForLock(categoryName, formName, entityId, formId)
                .pipe(takeUntil(_this.destroySubject$), first())
                .subscribe(function (condition) {
                if (condition) {
                    _this.drawerData = {
                        type: DrawerType.ENTITY,
                        formName: formName,
                        category: categoryName,
                        formId: formId,
                        params: params,
                        entityId: entityId,
                    };
                    _this.formService
                        .loadFormTypeId(formName, formId, categoryName)
                        .pipe(takeUntil(_this.destroySubject$))
                        .subscribe(function (type) {
                        _this.drawerClosable =
                            type === FormType.VIEW;
                        _this.drawer.toggle();
                    }, function (err) { return console.error(err); });
                }
            }, function (err) { return console.error(err); });
        })
            .build());
        this.actions.push(new ActionBuilder()
            .name('toggleFromEntityPopup')
            .params([])
            .action(function () {
            _this.parentContainer.drawer.toggle();
        })
            .build());
        this.actions.push(new ActionBuilder()
            .name('notifyParentForDrawerSave')
            .params([])
            .action(function (response) {
            _this.parentContainer.actionNotifier.next(new ActionNotificationData(ActionNotifierKey.DRAWER_SAVE_ACTION, response, _this.categoryName));
        })
            .build());
        this.actions.push(new ActionBuilder()
            .name('editExportTemplate')
            .params([])
            .action(function (template) {
            _this.drawerData = {
                type: DrawerType.EXPORT_TEMPLATE,
                template: template,
            };
            _this.drawer.toggle();
            _this.drawerClosable = false;
        })
            .build());
        this.actions.push(new ActionBuilder()
            .name('openComments')
            .params([])
            .action(function () { return _this.openComments(); })
            .build());
    };
    DeContainerComponent.prototype.handleDeLoadError = function (error) {
        switch (error.status) {
            case 404: {
                this._router.navigateByUrl('dynamic-de/deleted');
                break;
            }
            case 423: {
                this._router.navigateByUrl('dynamic-de/locked');
                break;
            }
        }
        return Observable.throw(error);
    };
    DeContainerComponent.prototype.initWorkflowActions = function () {
        if (notNil(this.form) && notNil(this.metaForm) && notNil(this.entity)) {
            this.form.initWorkflowActions();
        }
    };
    DeContainerComponent.prototype.initComments = function () {
        if (Boolean(this._activatedRoute.snapshot.queryParams['comments'])) {
            this.openComments();
        }
    };
    DeContainerComponent.prototype.openComments = function () {
        var _this = this;
        this.drawerData = {
            type: DrawerType.COMMENTS,
        };
        this.drawerClosable = true;
        this.drawer.toggle();
        var subscription = this.eventBase
            .listen('comment-drawer-state-change')
            .pipe(first())
            .subscribe(function () { return _this.drawer.toggle(); }, console.error);
        this.drawer.closedStart
            .pipe(first())
            .subscribe(function () { return subscription.unsubscribe(); }, console.error);
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DeContainerComponent.prototype, "categoryName", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], DeContainerComponent.prototype, "entityId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DeContainerComponent.prototype, "formName", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], DeContainerComponent.prototype, "actions", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], DeContainerComponent.prototype, "formId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DeContainerComponent.prototype, "isInDrawer", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DeContainerComponent.prototype, "transientFields", void 0);
    __decorate([
        Input(),
        __metadata("design:type", DeContainerComponent)
    ], DeContainerComponent.prototype, "parentContainer", void 0);
    __decorate([
        ViewChild('drawer'),
        __metadata("design:type", MatDrawer)
    ], DeContainerComponent.prototype, "drawer", void 0);
    __decorate([
        ViewChild('drawerForm'),
        __metadata("design:type", PopupEntityComponent)
    ], DeContainerComponent.prototype, "drawerForm", void 0);
    __decorate([
        Input(),
        __metadata("design:type", MainEntity),
        __metadata("design:paramtypes", [MainEntity])
    ], DeContainerComponent.prototype, "entity", null);
    __decorate([
        ViewChild('dynamicForm'),
        __metadata("design:type", DynamicFormComponent),
        __metadata("design:paramtypes", [DynamicFormComponent])
    ], DeContainerComponent.prototype, "form", null);
    DeContainerComponent = __decorate([
        Component({
            moduleId: module.id + '',
            selector: 'de-container',
            template: require('./de.container.component.html'),
        }),
        __param(13, Optional()),
        __metadata("design:paramtypes", [DeService,
            Router,
            ActivatedRoute,
            KbService,
            ValidationService,
            LanguageService,
            DePermissionService,
            FormService,
            LockingService,
            LockGuard,
            TokenInfoService,
            Title,
            MetaFormHelperService,
            DefaultModelDecoratorProvider,
            EventBase])
    ], DeContainerComponent);
    return DeContainerComponent;
}(AbstractDestructionSubject));
export { DeContainerComponent };
//# sourceMappingURL=de.container.component.js.map